import Vue from 'vue'
import store from './store'
import Router from 'vue-router'
import Home from './pages/Home'
import Login from './pages/Login'
import MethodsList from './pages/MethodsList'
import AddTask from './pages/AddTask'
import Settings from './pages/Settings'
import Files from './pages/Files'
import Datasets from './pages/Datasets'

Vue.use(Router)


const redirectIfAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const redirectIfNotAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      name: '404',
      component: () => import('./pages/err404.vue')
    },
    {
      path: "/m15h@",
      name: 'forMisha',
      component: () => import('./pages/forMisha.vue')
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        breadcrumbs: [
          { title: 'Главная', link: { name: 'home', disabled: true } }
        ]
      },
      beforeEnter: redirectIfNotAuthenticated
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        breadcrumbs: [
          { title: 'Вход', link: { name: 'login', disabled: true } }
        ]
      },
      beforeEnter: redirectIfAuthenticated
    },
    {
      path: '/registration',
      name: 'registration',
      component: () => import('./pages/Registration.vue'),
      meta: {
        breadcrumbs: [
          { title: 'Регистрация', link: { name: 'registration', disabled: true } }
        ]
      },
      beforeEnter: redirectIfAuthenticated
    },
    {
      path: '/methods/:platform',
      name: 'methods',
      component: MethodsList,
      meta: {
        breadcrumbs: [
          { title: 'Главная', link: { name: 'home' } },
          { title: 'Все методы', link: { name: 'methods', disabled: true } }
        ]
      },
      beforeEnter: redirectIfNotAuthenticated
    },
    {
      path: '/methods/:platform/:id',
      name: 'addTask',
      component: AddTask,
      meta: {
        breadcrumbs: [
          { title: 'Главная', link: { name: 'home' } },
          { title: 'Все методы', dynamic: true, link: { name: 'methods' } },
          { title: 'Новая задача', dynamic: true, link: { name: 'addTask', disabled: true }}
        ]
      },
      beforeEnter: redirectIfNotAuthenticated
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: {
        breadcrumbs: [
          { title: 'Главная', link: { name: 'home' } },
          { title: 'Настройки', link: { name: 'settings', disabled: true } }
        ]
      }
    },
    {
      path: '/files',
      name: 'files',
      component: Files,
      meta: {
        breadcrumbs: [
          { title: 'Главная', link: {name: 'home'} },
          { title: 'Файлы', link: {name: 'files', disabled: true} }
        ]
      }
    },
    {
      path: '/datasets',
      name: 'datasets',
      component: Datasets,
      meta: {
        breadcrumbs: [
          { title: 'Главная', link: {name: 'home'} },
          { title: 'Датасеты', link: {name: 'datasets', disabled: true} }
        ]
      }
    }
  ]
})
